import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';
import { ProviderTypes } from './constants';

import { CuiProviderRegistration } from './provider-registration';

export const FulfillmentProviderRegistration = ({
  providerApiCode,
  onBack = noop,
  onRegisterSuccess = noop,
  onRegisterFailure = noop,
  onError = noop,
  onCancel = noop,
}) => {
  return (
    <CuiProviderRegistration
      onBack={onBack}
      onCancel={onCancel}
      onError={onError}
      onRegisterFailure={onRegisterFailure}
      onRegisterSuccess={onRegisterSuccess}
      providerApiCode={providerApiCode}
      providerType={ProviderTypes.fulfillment}
    />
  );
};

FulfillmentProviderRegistration.propTypes = {
  providerApiCode: PropTypes.string.isRequired,
  onRegisterSuccess: PropTypes.func,
  onRegisterFailure: PropTypes.func,
  onBack: PropTypes.func,
  onError: PropTypes.func,
  onCancel: PropTypes.func,
};
